/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetValueForCategory$Params {
  id: string;
  x: number;
  y: number;
}

export function getValueForCategory(http: HttpClient, rootUrl: string, params: GetValueForCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, getValueForCategory.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('x', params.x, {});
    rb.path('y', params.y, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

getValueForCategory.PATH = '/v1/raster/value/category/{id}/{x}/{y}';
